import Vue from 'vue'
import '@/styles/element-variables.scss'
import { Button, Menu, Dropdown,  DropdownMenu, DropdownItem, Scrollbar, MenuItem, Form, FormItem, Row, Col, Input, InputNumber, Backtop, Breadcrumb, BreadcrumbItem, Drawer, Carousel, Card, Table, TableColumn, Progress, Tag, Icon, Timeline, Alert, Popover, Tabs, TabPane, Radio, RadioGroup, RadioButton, Checkbox, CheckboxButton, CheckboxGroup, Switch, Avatar, Submenu, Select, Option, DatePicker, TimePicker, Pagination, Divider, MessageBox, Message, Upload, Loading, Cascader, Tooltip, Image, Dialog, } from 'element-ui'

let messageInstance = null
const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close()
  }
  messageInstance = Message(options)
}
['error', 'success', 'info', 'warning'].forEach(type => {
  resetMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    return resetMessage(options)
  }
})

Vue.prototype.$message = resetMessage
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt

Vue.use(Button)
Vue.use(Menu)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Scrollbar)
Vue.use(MenuItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Backtop)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Drawer)
Vue.use(Carousel)
Vue.use(Card)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Progress)
Vue.use(Tag)
Vue.use(Icon)
Vue.use(Timeline)
Vue.use(Alert)
Vue.use(Popover)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Avatar)
Vue.use(Submenu)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Pagination)
Vue.use(Divider)
Vue.use(Upload)
Vue.use(Loading)
Vue.use(Cascader)
Vue.use(Image)
Vue.use(Tooltip)
Vue.use(Dialog)
